window.crUser = (function() {
	var userInfos = {};
	var portfolio = {};

	return {

		init: function() {
			// decrypt the cookie containing the user infos with the provided key
			if (typeof CryptoJS !== "undefined" && typeof UINFO !== "undefined" && UINFO) {
				if (typeof UTKN !== "undefined" && UTKN) {
					var decryptedStr = crCrypto.decrypt(UINFO, UTKN);
					var decrypted = JSON.parse(decryptedStr);
					userInfos = JSON.parse(decrypted);
				} else {
					// data are not encrypted
					userInfos = JSON.parse(UINFO);
				}
			}

			if (typeof UPORTFOLIO !== "undefined" && UPORTFOLIO) {
				portfolio = UPORTFOLIO;
			}
		},

		/**
		 * This function will return the user informations
		 * @return {Object} user informations (name, email, usrId)
		 */
		getInfos: function() {
			return userInfos;
		},

		/**
		 * This function will return the Agent List
		 * @return {Object} agents (name, token)
		 */
		getPortfolio: function() {
			return portfolio;
		},

		/**
		 * This function will set the new portfolio keeping the first folio (private folder)
		 * @param  {Object} folios list of folios
		 * @return {Object}        list of folios
		 */
		setPortfolio: function(folios) {
			portfolio = [portfolio[0]].concat(folios);
		}

	};
})();
